import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';

import CustomerOrderItem, { ICustomerOrderItem } from './CustomerOrderItem';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    root: {
        cursor: 'pointer',
    },
    title: {
        fontSize: '0.9375rem',
        lineHeight: '1.25rem',
        color: '#8D98B7',
        marginBottom: '1.875rem',
    },
    list: {
        maxHeight: '50vh',
        overflow: 'auto',
        padding: '0 0.9375rem',
    },
});

export interface ICustomerOrderHistory {
    items: ICustomerOrderItem[];
    onSelectItem: (id: string) => void;
}

const CustomerOrderHistory = (props: ICustomerOrderHistory) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const renderOrderItems = () => {
        return props.items.map((item: ICustomerOrderItem) => (
            <CustomerOrderItem key={item.id} {...item} onSelectItem={props.onSelectItem} />
        ));
    };
    return (
        <div className={classes.root}>
            <div className={classes.title}>{t('customers.modal.orderHistory')}</div>
            <div className={classes.list}>{renderOrderItems()}</div>
        </div>
    );
};

export default CustomerOrderHistory;
